import { useState, FC, useEffect } from "react";
import { Course } from "../data/DataDefinition/SearchWordDD";
import { Section } from "../data/DataDefinition/SectionDD";
import { SectionsProvider } from "./calendar/context/SectionsContext";
import {Box, Stack} from "@mui/material";
import { ThemeProvider } from '@mui/material/styles';
import TopNavigationBar from "./topnavbar/TopNavigationBar";
import CourseSearchPaper from "./coursesearch/CourseSearchPaper";
import OptionsPaper from "./OptionsPaper";
import Calendar from "./calendar/1. calendar/Calendar";
import { theme } from "./Theme";
import { Recommended } from "../data/DataDefinition/RecommendDD";
// import Instructions from "./Instructions";
// import History from "./History";
import { HistoryProvider } from "./context/HistoryContext";
import TutorialPopup from "./TutorialPopup";


/**
 * User selected course description
 * @typedef  {Object}   Course
 */
export interface Recommendation {
  compact: Section[];
  consistent: Section[];
  scatter: Section[];
  earlyStart: Section[];
  lateStart: Section[];
  earlyEnd: Section[];
  lateEnd: Section[];
  freeDay: Section[];
}

const Main: FC = () => {

  /** initial tutorial pop-up **/
  const [open, setOpen] = useState(true);
  const openInstructions = () => {setOpen(true)};

  /** all sections that were fetched from web scrapper */
  const [sections, setSections] = useState<Section[]>([]);

  /** sections that were recommended, each array is a recommendation */
  const [recommended, set_recommended] = useState<Recommendation>(
    {
      compact: [], consistent: [], scatter: [], earlyStart: [], 
      lateStart: [], earlyEnd: [], lateEnd: [], freeDay: [],
    }
  );

  /** courses that users looked up and want to get scheduled */
  const [coursesToFetch, setCoursesToFetch] = useState<Course[]>([]);

  /** raw user input from search bar and term selection components */
  const [userTerm, setUserTerm] = useState<string>("1");
  const [season, ] = useState<string>("W");


  /** indicates the current category of recommendation that user selected*/
  const [selectedRecommended, setSelectedRecommended] = useState<Recommended>(Recommended.compact)

  /** currently viewed sections that is selected from recommended data */
  const [currentRecommended, setCurrentRecommended] = useState<Section[]>([])
  
  /** Switch currently view sections whenever selected is changed from user's selection*/
  useEffect(() => {
    switch (selectedRecommended) {
      case Recommended.compact:
        setCurrentRecommended(recommended.compact) 
        break;
      case Recommended.scattered:
        setCurrentRecommended(recommended.scatter) 
        break;
      case Recommended.consistent:
        setCurrentRecommended(recommended.consistent) 
        break;
      default:
        setCurrentRecommended(recommended.freeDay)
        break;
    }
  }, [selectedRecommended, recommended])

 

  return (
      <ThemeProvider theme={theme}>

        <TutorialPopup open={open} setOpen={setOpen}/>

        <div className="Page">
          <TopNavigationBar openInstructions={openInstructions}/>
          <Box m={2} sx={{height:"100%"}}>
            <div className="main-page-flexbox">
              <div className="main-page-left">
                <Stack direction="column" spacing={2}>
                {/*<Instructions />*/}
                  <CourseSearchPaper coursesToFetch={coursesToFetch}
                                     setCoursesToFetch={setCoursesToFetch}
                                     set_recommended={set_recommended}
                                     userTerm={userTerm}
                                     setUserTerm={setUserTerm}
                                     setSections={setSections}
                                     season={season}
                  />
                  <OptionsPaper setSelectedRecommended={setSelectedRecommended}/>
                  
                </Stack>
              </div>
              <div className="main-page-right">

                <SectionsProvider allSections={sections}>
                <HistoryProvider setCurrentRecommended={setCurrentRecommended}>
                  <Stack direction="column" spacing={1}>
                    {/*<History />*/}
                      <Calendar recommended={currentRecommended}/>
                  </Stack>
                </ HistoryProvider>
                </ SectionsProvider>

              </div>
            </div>
          </Box>
        </div>
      </ThemeProvider>
  );
};

export default Main;
